import { render, staticRenderFns } from "./ItemHistoryChangeTypeDateTimeLocal.vue?vue&type=template&id=9aaa90e0&scoped=true"
import script from "./ItemHistoryChangeTypeDateTimeLocal.vue?vue&type=script&lang=js"
export * from "./ItemHistoryChangeTypeDateTimeLocal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aaa90e0",
  null
  
)

export default component.exports